import { LoaderCircle } from 'lucide-react'

export default function Button({
  children,
  variant = 'primary',
  size = 'default',
  loading = false,
  iconOnly = false,
  className = '',
  disabled,
  type = 'button',
  ...props
}) {
  const classes = ['button', `button-${variant}`, `button-${size}`, iconOnly ? 'button-icon' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <button className={classes} type={type} disabled={disabled || loading} {...props}>
      {loading && <LoaderCircle className="spin" aria-hidden="true" />}
      {children}
    </button>
  )
}
